<mat-progress-bar [value]="progress" color="warn"></mat-progress-bar>
<button mat-icon-button class="closeSnackBar" (click)="close()"><mat-icon>close</mat-icon></button>
<span [innerHTML]="error.errorMessage">{{error.errorMessage}}</span>
